<template>
    <div class="animated fadeIn">
        <b-card>
            <h5 class="mb-0">
                <i class="fa fa-fw fa-archive mr-2" />Request Stock PEI
            </h5>
            <hr />
            <b-row class="mb-2">
                <b-col md="3">
                    <b-form-group label="No. Request" class="mb-0">
                        <b-input-group>
                            <b-form-input
                                v-model="filter.no_request"
                                maxlength="50"
                                @keydown.enter="getItems"
                                placeholder="Cari No. Request..."
                            />
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Status" class="mb-0">
                        <b-form-select
                            v-model="filter.status"
                            :options="optFilterStatus"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Aksi">
                        <div class="d-flex flex-nowrap d-flex">
                            <b-button variant="primary" @click="getItems">
                                <i class="fa fa-search mr-2" />Cari
                            </b-button>
                            <b-button
                                class="ml-2"
                                variant="danger"
                                @click="resetFilter"
                            >
                                Reset
                            </b-button>
                        </div>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-table
                bordered
                hover
                show-empty
                no-local-sorting
                :busy="isBusy"
                :items="items"
                :fields="fields"
                responsive
                class="mb-3"
            >
                <template v-slot:empty>
                    Tidak ada data request.
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge
                        :variant="getStatusBadge(row.item.status, row.item.is_po).variant"
                        :class="getStatusBadge(row.item.status, row.item.is_po).class"
                    >
                        {{ getStatusBadge(row.item.status, row.item.is_po).label }}
                    </b-badge>
                </template>

                <template v-slot:cell(is_po)="row">
                    <span class="font-weight-bold small">{{
                        row.item.is_po ? "PO" : "NON-PO"
                    }}</span>
                </template>

                <template v-slot:cell(request)="row">
                    <div class="small">
                        <div>
                            <strong>Diminta:</strong>
                            {{ row.item.requested_by }} -
                            {{ $helper.formatDate(row.item.requested_at) }}
                        </div>
                        <div>
                            <strong>Diproses:</strong>
                            <span v-if="row.item.processed_at">
                                {{ row.item.processed_by }} -
                                {{
                                    $helper.formatDate(row.item.processed_at)
                                }}</span
                            >
                            <span v-else> -</span>
                        </div>
                    </div>
                </template>
                <template v-slot:cell(action)="row">
                    <div
                        class="d-flex justify-content-center align-items-center"
                    >
                        <router-link
                            :to="'/emas/request-stock-pei/' + row.item.id"
                            class="pr-2"
                        >
                            <b-button
                                size="sm"
                                variant="primary"
                                v-b-tooltip.hover.top
                                title="Detail Request"
                            >
                                <i class="fa fa-fw fa-info" />
                            </b-button>
                        </router-link>
                    </div>
                </template>
            </b-table>
            <PageSizer
                :totalRows="totalRows"
                :page="currentPage"
                :options="options"
                @limit-change="onLimitChange"
                @page-change="onPageChange"
            />
        </b-card>
    </div>
</template>

<script>
import { REQUEST_STATUS as RequestStatus, requestStatusBadge } from "./pei";

export default {
    data() {
        return {
            isBusy: true,

            filter: {
                no_request: "",
                status: -1
            },

            optFilterStatus: [
                { value: -1, text: "Semua" },
                { value: RequestStatus.PENDING, text: "PENDING" },
                { value: RequestStatus.PEI_APPROVED, text: "PENDING (PO)" },
                { value: RequestStatus.APPROVED, text: "DISETUJUI" },
                { value: RequestStatus.PROCESSED, text: "DIPROSES" },
                { value: RequestStatus.COMPLETED, text: "SELESAI" },
                { value: RequestStatus.CANCELLED, text: "DIBATALKAN" }
            ],

            options: [
                { value: 10, text: "10" },
                { value: 20, text: "20" },
                { value: 30, text: "30" },
                { value: 40, text: "40" },
                { value: 50, text: "50" }
            ],

            fields: [
                { key: "no_request", label: "No. Request", sortable: false },
                { key: "total_item", label: "Qty Diminta", sortable: false },
                {
                    key: "item_processed",
                    label: "Sudah Dikemas",
                    sortable: false
                },
                { key: "branch", label: "Cabang", sortable: false },
                { key: "address", label: "Alamat", sortable: false },
                {
                    key: "is_po",
                    label: "Jenis",
                    thClass: "text-center",
                    tdClass: "text-center",
                    sortable: false
                },
                {
                    key: "status",
                    label: "Status",
                    thClass: "text-center",
                    tdClass: "text-center",
                    sortable: false
                },
                {
                    key: "request",
                    label: "Detail Request",
                    sortable: false
                },
                { key: "action", label: "Aksi", sortable: false }
            ],

            items: [],
            currentPage: 1,
            perPage: 10,
            totalRows: 0
        };
    },

    methods: {
        getItems(page = 1) {
            this.isBusy = true;
            this.items = [];

            if (isNaN(page)) {
                this.currentPage = 1;
            } else {
                this.currentPage = page;
            }

            let param = this.$helper.getBasePagedQuery(
                this.currentPage,
                this.perPage,
                true
            );

            if (this.filter.no_request) {
                param += `&no_request=${this.filter.no_request}`;
            }

            if (this.filter.status != -1) {
                param += `&status=${this.filter.status}`;
            }

            return this.$axios
                .get("request-pei" + param)
                .then(res => {
                    this.items = res.data.data.items;
                    this.totalRows = res.data.data.total;
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },

        resetFilter() {
            this.filter.no_request = "";
            this.filter.status = -1;
            this.getItems();
        },

        getStatusBadge: requestStatusBadge,

        onLimitChange(newPerPage) {
            this.perPage = newPerPage;
            this.getItems(this.currentPage);
        },

        onPageChange(newPage) {
            this.currentPage = newPage;
            this.getItems(this.currentPage);
        }
    },

    created() {
        this.getItems();
        this.$helper.toastFlash(this);
    }
};
</script>
